// Allow this file to be used external to Django templates, like our
// base.html that defines `Mustache.templates`
if (typeof window.Mustache === 'undefined') {
  window.Mustache = {};
}

// Mustache defines a `.to_html` function - perform the import
// and merge the objects if it's already defined.
if (typeof window.Mustache.to_html === 'undefined') {
  // eslint-disable-next-line
  const MustacheModule = require('mustache');
  window.Mustache = { ...window.Mustache, ...MustacheModule };
}

// override Mustache.render and to_html to provide global translation function
function patchWithTranslation(view) {
  const i18n = require('@rover/utilities/translation');
  view = view || {};
  view.t = () => (text, render) => {
    if (!(text && render)) {
      return;
    }

    if (Rover.context.frontendTranslationEnabled) {
      return i18n._(render(text), view);
    }
    return render(text);
  };
  return view;
}

const _render = Mustache.render;
Mustache.render = (template, view, ...args) => {
  view = patchWithTranslation(view);
  return _render.call(Mustache, template, view, ...args);
};

const _to_html = Mustache.to_html;
Mustache.to_html = (template, view, ...args) => {
  view = patchWithTranslation(view);
  return _to_html.call(Mustache, template, view, ...args);
};

export default window.Mustache;



// WEBPACK FOOTER //
// ../globals/Mustache.js